export default class DuiForm {
  constructor() {
    this.form = $('#dmv_dui_form');
    this.navLinkSelector = '.dmv-dui-widget nav > ul > li';
    this.links = document.querySelectorAll(this.navLinkSelector);
    this.nextButton = document.querySelector('#dmv_dui_form .btn-next');
  }

  validate() {
    if (this.form.length) {
      this.links.forEach(link => {
        link.addEventListener('click', () => {
          this.validateForm(link);
        });
      });

      this.nextButton.addEventListener('click', () => {
        this.validateForm(this.nextButton);
      });
    }
  }

  validateForm(clickedLink) {
    this.form.formValidation({
      framework: 'bootstrap',
      icon: {
        valid: 'icon icon-success',
        invalid: 'icon icon-danger',
        validating: 'fa fa-refresh',
      },
      fields: {
        first_name: {
          validators: {
            notEmpty: {
              message: 'The first name is required',
            },
          },
        },
        last_name: {
          validators: {
            notEmpty: {
              message: 'The last name is required',
            },
          },
        },
        phone: {
          validators: {
            notEmpty: {
              message: 'The phone number is required',
            },
          },
        },
        email: {
          validators: {
            notEmpty: {
              message: 'Email is required',
            },
            emailAddress: {
              message: 'You must use a valid email address',
            },
          },
        },
        address: {
          validators: {
            notEmpty: {
              message: 'The postal address is required',
            },
          },
        },
        zip: {
          validators: {
            notEmpty: {
              message: 'The zip code is required',
            },
          },
        },
        option1: {
          validators: {
            notEmpty: {
              message: 'Select an option',
            },
          },
        },
        option2: {
          validators: {
            notEmpty: {
              message: 'Select an option',
            },
          },
        },
        option3: {
          validators: {
            notEmpty: {
              message: 'Select an option',
            },
          },
        },
        option4: {
          validators: {
            notEmpty: {
              message: 'Select an option',
            },
          },
        },
        option5: {
          validators: {
            notEmpty: {
              message: 'Select an option',
            },
          },
        },
        option6: {
          validators: {
            notEmpty: {
              message: 'Select an option',
            },
          },
        },
        agreement: {
          validators: {
            notEmpty: {
              message: 'You need to agree to our terms',
            },
          },
        },
      },
    }).on('success.form.fv', () => {
      $('#dmv_dui_form .alert').remove();
      if (clickedLink.dataset.goto) {
        this.links.forEach(link => {
          $(link).removeClass('active');
        });
        $(clickedLink).addClass('active');

        if ($(clickedLink).hasClass('btn-next')) {
          $("#claim-details-link").addClass('active');
        }

        $('#dmv_dui_form .form-section').addClass('d-none');
        $(clickedLink.dataset.goto).removeClass('d-none');

        $('.form-submit').removeAttr('disabled');
        $('.form-submit').removeClass('disabled');
      } else {
        this.form.submit();
      }
    });

    this.form.formValidation('validate');
  }
}



// WEBPACK FOOTER //
// ./scripts/plugins/dmv-lawyers/dui-form.js